import { render, staticRenderFns } from "./UpdateWorkshopTasksViaExcelModal.vue?vue&type=template&id=0afb6d0e&scoped=true&"
import script from "./UpdateWorkshopTasksViaExcelModal.vue?vue&type=script&lang=js&"
export * from "./UpdateWorkshopTasksViaExcelModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateWorkshopTasksViaExcelModal.vue?vue&type=style&index=0&id=0afb6d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb6d0e",
  null
  
)

export default component.exports